export const FONT_SIZE_WEB = 16
export const FONT_SIZE_TITLE_WEB = 16
export const FONT_SIZE_SUBTITLE_WEB = 14
export const FONT_WEIGHT_WEB = 'normal'
export const FONT_WEIGHT_TITLE_WEB = 'bold'
export const FONT_WEIGHT_SUBTITLE_WEB = '300'
